export default [
	{ name: "Home", path: "/" },
	{ name: "Businesses", path: "/business/" },
	{ name: "Film & Theater", path: "/films/" },
	{ name: "About Us", path: "/about/" },
];
